export default function woocommerce() {
	const updateBtnState = () => {
		const $check = document.querySelector('#wine-warning');
		const $proceedBtn = document.querySelector('a.checkout-button');
		// Disable the button if the warning message is found
		if ($proceedBtn instanceof window.HTMLElement) {
			if (
				typeof $check !== undefined &&
				typeof $check !== 'undefined' &&
				$check !== null
			) {
				$proceedBtn.classList.add('disabled');
			} else {
				$proceedBtn.classList.remove('disabled');
			}
		}
	};
	jQuery(document.body).on('updated_cart_totals', updateBtnState);
	updateBtnState();
}
